import { render } from "./ClassUploads.vue?vue&type=template&id=3581b44e"
import script from "./ClassUploads.vue?vue&type=script&lang=js"
export * from "./ClassUploads.vue?vue&type=script&lang=js"

import "./ClassUploads.vue?vue&type=style&index=0&id=3581b44e&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__